<template>
  <div class="managed-object-list">
    <div class="search">
      <w-search-field ref="searchField" @search="filterTree"/>
    </div>
    <el-scrollbar style="height: calc(100% - 50px); margin-top: 10px;">
      <el-tree class="draggable" :ref="treeRef" :data="treeData" :props="defaultProps" :node-key="defaultProps.treeKey" :expand-on-click-node="false" :filter-node-method="filterNode">
        <span class="el-tree-node__label" slot-scope="{ node, data }">
          <!-- obj -->
          <drag v-if="isObjNode(data)" :transfer-data="node" @dragstart="onDragObj" @dragend="onDragEnd" style="display: inline; line-height:19px; padding-left: 3px;">
            <!-- <span>{{ node.label }}</span> -->
            <el-tooltip v-if="isObjNode(data) && isRequireIPObjType(data)" class="item" effect="dark" :content="getIpTooltipContent(data)" placement="right">
              <span>
                <span v-if="hasObjTypeIcon(data)" class="obj-icon">
                  <i :class="getObjTypeIconClass(data)"></i>
                </span>
              <span>{{data.label}}</span>
            </span>
            </el-tooltip>
            <span v-else-if="isObjNode(data)">
              <span v-if="!isEmpty(data.subType)" class="obj-icon">
                <i :class="getObjTypeIconClass(data)"></i>
              </span>
              <span>{{data.label}}</span>
            </span>
          </drag>
          <!-- root, group -->
          <span v-else class="group">{{ node.label }}</span>
        </span>
      </el-tree>
    </el-scrollbar>
  </div>
</template>

<script>
import { Drag } from 'vue-drag-drop';
import isEmpty from 'lodash/isEmpty';
import TreeFilter from '@/mixins/tree/filter';
import { defaultProps, treeType, rootNode } from '@/constants/tree';
import TreeAPI from '@/api/common/tree';
import { isRequireIPObjType, getObjTypeIconClass, isObjNode, getIpTooltipContent, hasObjTypeIcon } from '@/utils/tree';
import { getValueAfterCheckEmpty } from '@/utils/string';

import DashboardConst from '@/constants/dashboard';

import WSearchField from '@/components/form/SearchField';

export default {
  name: 'WManagedObjectList',
  mixins: [TreeFilter],
  components: {
    Drag,
    WSearchField,
  },
  data() {
    return {
      treeRef: `${treeType.LOGICAL}Tree`,
      treeData: null,
      defaultProps,
    };
  },
  computed: {
    viewMode() {
      return this.$store.getters.getDashboardViewMode;
    },
  },
  watch: {
    viewMode(value) {
      if (value === DashboardConst.VIEW_MODE.EDIT && this.$refs.searchField) {
        this.$refs.searchField.clear();
      }
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    isEmpty,
    isObjNode,
    isRequireIPObjType,
    hasObjTypeIcon,
    getObjTypeIconClass,
    getIpTooltipContent,
    getValueAfterCheckEmpty,
    onDragObj(data, evt) {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_ADD_START, data, evt);
      this.$emit('dragTreeNode', data);
    },
    onDragEnd(data, evt) {
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_ADD_END, data, evt);
      this.$emit('dragendTreeNode');
    },
    loadData() {
      TreeAPI.getLogicalTreeData({}).then((response) => {
        this.treeData = [response.data.children];
        this.$nextTick(() => {
          const root = this.$refs[this.treeRef].getNode(rootNode.treeKey);
          this.$refs[this.treeRef].setCurrentKey(root);
          root.expanded = true;
        });
      });
    },
  },
};
</script>

<style lang="scss">
.managed-object-list {
  .el-tree-node__content {
    cursor: default;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/ManagedObjectList.vue